const styles = (theme) => {
  const secondaryBg = theme.palette.secondary.main || '#fff'
  const secondaryText = theme.palette.secondary.contrastText || '#333'
  const primaryRed = '#E60000'

  return {
    navsec: {
      width: '100%',
      backgroundColor: secondaryBg,
      boxShadow: '0px 2px 6px rgba(0,0,0,0.08)',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 1200,
    },

    navDummyFill: {
      height: '80px',
    },

    menuSection: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      minHeight: '80px',
      position: 'relative',
    },

    menuSystem: {
      display: 'flex',
      alignItems: 'center',
      minWidth: '220px',
      zIndex: 1300,
    },

    menuHumbergar: {
      width: '40px',
      height: '40px',
      display: 'none',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'transparent',
      border: 0,
      cursor: 'pointer',
      marginRight: '12px',
      padding: 0,

      '@media (max-width:1024px)': {
        display: 'flex',
      },
    },

    burger: {
      fontSize: '20px',
      width: '20px',
      height: '20px',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    colorIcon: {
      color: secondaryText,
    },

    // DESKTOP LEFT NAV
    leftNestedNavContainer: {
      marginLeft: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flex: 1,
      color: secondaryText,
      

      '& .holder': {
        display: 'flex',
        alignItems: 'center',
      },

      '& .menuItem': {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        background: 'transparent',
        border: 0,
        color: 'currentColor',
        textDecoration: 'none',
        cursor: 'pointer',
        fontFamily: theme.fontFamily?.fontFamilyRegular || 'VodafoneRg-Regular',
        fontSize: '1rem',
        padding: '28px 10px',
        whiteSpace: 'nowrap',
        boxSizing:'border-box',

        '&:hover': {
          color: primaryRed,
        },

        '&.active': {
          color: primaryRed,
        },

        '&:after': {
          content: '""',
          position: 'absolute',
          left: 0,
          bottom: '0px',
          width: 0,
          height: '2px',
          background: primaryRed,
          transition: 'width 0.25s ease',
        },

        '&:hover:after': {
          width: '100%',
        },
      },

      '& .dropdown-toggle': {
        display: 'flex',
        alignItems: 'center',
        background: 'transparent',
        border: 0,
        color: 'currentColor',
        fontFamily: theme.fontFamily?.fontFamilyRegular || 'VodafoneRg-Regular',
        fontSize: '1rem',
        cursor: 'pointer',
      },

      '& .dropdown-menu': {
        background: secondaryBg,
        color: secondaryText,
        marginTop: '8px',
        minWidth: '220px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
        borderRadius: '8px',
        padding: '10px 0',
        border:'0',
        margin:'0',

        '& li': {
          listStyle: 'none',
          margin: 0,
        },

        '& .menuItem': {
          padding: '10px 16px',
          width: '100%',
        },
      },

      '& .btn-transparent': {
        width: '100%',
        border: 0,
        margin: 0,
        background: 'transparent',
        color: 'currentColor',
        cursor: 'pointer',
        textAlign: 'left',
        padding: '10px 16px',
        textTransform: 'uppercase',


        '&:hover': {
          color: primaryRed,
        },
      },

      '& .btn-transparent:disabled': {
        opacity: 0.5,
        pointerEvents: 'none',
        cursor: 'default',
      },

      '@media (max-width:1024px)': {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '280px',
        height: '100vh',
        marginLeft: 0,
        background: secondaryBg,
        zIndex: 1400,
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
        padding: '16px 0 24px',
        boxShadow: '2px 0 15px rgba(0,0,0,0.15)',
        overflowY: 'auto',
        transform: 'translateX(-100%)',
        transition: 'transform 0.3s ease',

        '& .holder': {
          display: 'block',
          width: '100%',
          padding: 0,
        },

        '& .menuItem': {
          width: '100%',
          padding: '14px 20px',
          fontSize: '1rem',
          boxSizing:'border-box',
          '&:after': {
            display: 'none',
          },
        },

        '& .dropdown-toggle': {
          width: '100%',
          padding: '14px 20px',
          justifyContent: 'space-between',
        },

        '& .dropdown-menu': {
          boxShadow: 'none',
          borderRadius: 0,
          minWidth: '100%',
          marginTop: 0,
          padding: 0,
          border:0,
          margin:0,

          '& .menuItem': {
            paddingLeft: '32px',
          },
        },

        '& .btn-transparent': {
          paddingLeft: '32px',
        },
      },
    },

    mobileDrawerOpen: {
      '@media (max-width:1024px)': {
        transform: 'translateX(0)',
      },
    },

    mobileDrawerClose: {
      '@media (max-width:1024px)': {
        transform: 'translateX(-100%)',
      },
    },

    mobileOverlay: {
      display: 'none',

      '@media (max-width:1024px)': {
        display: 'block',
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 1350,
        border:'0',
        padding:'0',
        margin:'0'
      },
    },

    mobileDrawerHeader: {
      display: 'none',

      '@media (max-width:1024px)': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 16px 16px',
        borderBottom: '1px solid #e5e5e5',
        marginBottom: '8px',
      },
    },

    drawerTitle: {
      fontSize: '1.125rem',
      fontWeight: 600,
      color: secondaryText,
    },

    drawerCloseBtn: {
      border: 0,
      background: 'transparent',
      cursor: 'pointer',
      fontSize: '20px',
      color: secondaryText,
    },

    rightNestedNavContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      marginLeft: '16px',
      minWidth: '220px',
      gap: '12px',

      '@media (max-width:1024px)': {
        minWidth: 'auto',
        gap: '8px',
      },

      '@media (max-width:767px)': {
        marginLeft: '8px',
      },
    },

    postIdea: {
      height: '42px',
      minWidth: '140px',
      border: 0,
      borderRadius: '999px',
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      fontFamily: theme.fontFamily?.fontFamilyRegular || 'VodafoneRg-Regular',
      fontSize: '1rem',
      cursor: 'pointer',
      padding: '0 18px',
      whiteSpace: 'nowrap',

      '&:disabled': {
        opacity: 0.6,
        cursor: 'not-allowed',
      },

      '@media (max-width:767px)': {
        minWidth: 'auto',
        padding: '0 12px',
        fontSize: '0.9rem',
      },

      '@media (max-width:480px)': {
        display: 'none',
      },
    },

    profilePicHolder: {
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      gap: '8px',
    },

    profilePic: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      boxShadow: '0px 2px 6px rgba(0,0,0,0.18)',
      marginLeft: '.5rem',
    },

    notificationsBadge: {
      width: '.5rem',
      height: '.5rem',
      borderRadius: '50%',
      background: 'red',
      position: 'absolute',
      top: 0,
      right: 0,
    },

    iconbell: {
      color: secondaryText,
    },

    dropdownToggle: {
      display: 'flex',
      alignItems: 'center',
      background: 'transparent',
      border: 0,
      padding: 0,
      margin: 0,
      color: 'currentColor',
      cursor: 'pointer',
    },

    chevronDown: {
      width: '14px',
      height: '14px',
      marginLeft: '6px',
    },

    navList: {
      position: 'relative',
    },

    badge: {
      borderRadius: '20px',
      lineHeight: '20px',
      backgroundColor: '#F63F40',
      color: '#FFFFFF',
      display: 'flex',
      justifyContent: 'center',
      position: 'absolute',
      right: -3,
      top: '65%',
      padding: '1px',
      cursor: 'pointer',
    },

    notifications: {
      zIndex: 5,
      position: 'absolute',
      right: 30,
      top: '65%',
      backgroundColor: '#F63F40',
      color: '#FFFFFF',
      fontFamily: 'VodafoneRg-Regular',
      padding: '1px 6px',
      borderRadius: '25px',
      fontSize: '17px',
      cursor: 'pointer',
    },

    btnRelative: {
      position: 'relative',
      cursor: 'pointer',
    },

    dotIcon: {
      backdropFilter: 'blur(5px)',
      width: '32px',
      padding: 0,
      display: 'block',
      position: 'absolute',
      bottom: '4px',
      left: '12px',
      borderBottomRightRadius: '10px',
      borderBottomLeftRadius: '10px',
      color: '#1b1d21',
      fontSize: '23px',
      lineHeight: 0,
      fontFamily: 'VodafoneRg-Bold',
      height: '10px',
    },
  }
}

export default styles